import { SURVEY_ANSWER_TYPES, SURVEY_QUESTION_TYPES } from "./constants"

export const checkIfAnswerIsSelected = (answer, questionType) => {
  if (!questionType || !answer) return true

  if (questionType === SURVEY_QUESTION_TYPES.SINGLE_CHOICE) {
    if (!answer.selected) return false

    if ((answer.type === SURVEY_ANSWER_TYPES.TEXT || answer.type === SURVEY_ANSWER_TYPES.TEXTAREA) && (String(answer?.content || '')?.trim?.()?.length || 0) < 1) {
      return false
    }

    if (
      answer.type === SURVEY_ANSWER_TYPES.NUMBER &&
      (answer?.value === undefined ||
        answer?.value === null ||
        answer?.value === '' ||
        (answer?.value !== 0 && !answer?.value) ||
        answer?.value < answer?.minValue ||
        answer?.value > answer?.maxValue)
    ) {
      return false
    }

    return true
  } else if (questionType === SURVEY_QUESTION_TYPES.DROPDOWN_LIST) {
    return !!answer.selected
  } else if (questionType === SURVEY_QUESTION_TYPES.NUMBER) {
    // If number, check if there is a value and value is between requirements, return false
    const isIncorrect = (
      answer?.value === undefined ||
      answer?.value === null ||
      answer?.value === '' ||
      (answer?.value !== 0 && !answer?.value) ||
      answer?.value < answer?.minValue ||
      answer?.value > answer?.maxValue)

    return !isIncorrect
  } else if (questionType === SURVEY_QUESTION_TYPES.TEXT) {
    const isIncorrect = (String(answer?.content || '')?.trim?.()?.length || 0) < 1
    return !isIncorrect;
  } else if (questionType === SURVEY_QUESTION_TYPES.MULTI_CHOICE) {
    if (!answer.selected) return false
    
    // Checkbox with number
    if (answer.type === SURVEY_ANSWER_TYPES.NUMBER) {
      return !(answer?.value === undefined ||
        answer?.value === null ||
        answer?.value === '' ||
        (answer?.value !== 0 && !answer?.value) ||
        answer?.value < answer?.minValue ||
        answer?.value > answer?.maxValue)
    }

    if (answer.type === SURVEY_ANSWER_TYPES.TEXT || answer.type === SURVEY_ANSWER_TYPES.TEXTAREA) {
      return (String(answer?.content || '')?.trim?.()?.length || 0) >= 1
    }

    return true
  }
}

export const checkIfAnswered = (question, ignoreEmbeddedQuestions = false) => {
  const answers = question.answers
  if (question.type === SURVEY_QUESTION_TYPES.SINGLE_CHOICE) {
    const selectedAnswer = answers.find(el => !!el.selected)

    // If there is no selected answer, then return false
    if (!selectedAnswer) {
      return false
    }

    // If answer is selected, and is type text, but without content, return false
    if (
      (selectedAnswer.type === SURVEY_ANSWER_TYPES.TEXT || selectedAnswer.type === SURVEY_ANSWER_TYPES.TEXTAREA) &&
      (String(selectedAnswer?.content || '')?.trim?.()?.length || 0) < 1
    ) {
      return false
    }

    // If answer is selected, and is type number, but without value or value isn't between requirements, return false
    if (
      selectedAnswer.type === SURVEY_ANSWER_TYPES.NUMBER &&
      (selectedAnswer?.value === undefined ||
        selectedAnswer?.value === null ||
        selectedAnswer?.value === '' ||
        (selectedAnswer?.value !== 0 && !selectedAnswer?.value) ||
        selectedAnswer?.value < selectedAnswer?.minValue ||
        selectedAnswer?.value > selectedAnswer?.maxValue)
    ) {
      return false
    }

    // Check if embedded question answerred
    if (!ignoreEmbeddedQuestions && selectedAnswer && selectedAnswer.embeddedQuestion) {
      return !!checkIfAnswered(selectedAnswer.embeddedQuestion)
    }

    return true
  } else if (question.type === SURVEY_QUESTION_TYPES.DROPDOWN_LIST) {
    // If dropdown list, check if there is an selected item
    const selectedAnswer = answers.find(el => !!el.selected)

    // Check if embedded question answerred
    if (!ignoreEmbeddedQuestions && selectedAnswer && selectedAnswer.embeddedQuestion) {
      return selectedAnswer && !!checkIfAnswered(selectedAnswer.embeddedQuestion)
    }

    return !!selectedAnswer
  } else if (question.type === SURVEY_QUESTION_TYPES.NUMBER) {
    // If number, check if there is a value and value is between requirements, return false
    const isIncorrect = answers
      .filter(el => el.type === SURVEY_ANSWER_TYPES.NUMBER)
      .find(el => (
        el?.value === undefined ||
        el?.value === null ||
        el?.value === '' ||
        (el?.value !== 0 && !el?.value) ||
        el?.value < el?.minValue ||
        el?.value > el?.maxValue))

    return !isIncorrect
  } else if (question.type === SURVEY_QUESTION_TYPES.TEXT) {
    // If text, check if content is at least 1 char length
    const isIncorrect = answers.filter(el => (el.type === SURVEY_ANSWER_TYPES.TEXT || el.type === SURVEY_ANSWER_TYPES.TEXTAREA)).find(el => (String(el?.content || '')?.trim?.()?.length || 0) < 1)
    return !isIncorrect;
  } else if (question.type === SURVEY_QUESTION_TYPES.MULTI_CHOICE) {
    // If multi choice, check if there is an selected item
    const checkedAnswers = answers.filter(el => !!el.selected)
    
    // Checkbox with number
    const checkboxNumberAnswers = checkedAnswers.filter(el => el.type === SURVEY_ANSWER_TYPES.NUMBER)
    const isOneWrongNumberAnswer = !!checkboxNumberAnswers.find(
      el => el?.value === undefined ||
      el?.value === null ||
      el?.value === '' ||
      (el?.value !== 0 && !el?.value) ||
      el?.value < el?.minValue ||
      el?.value > el?.maxValue)

    // Checkbox with text
    const checkboxTextAnswers = checkedAnswers.filter(el => el.type === SURVEY_ANSWER_TYPES.TEXT || el.type === SURVEY_ANSWER_TYPES.TEXTAREA)
    const isOneEmptyTextAnswer = !!checkboxTextAnswers.find(el => (String(el?.content || '')?.trim?.()?.length || 0) < 1)

    // Return false when there is no checked answer or checked text type, but without content, or checked number type, but without value or value isn't between requirements
    const isChecked =
      checkedAnswers.length > 0 &&
      !isOneWrongNumberAnswer &&
      !isOneEmptyTextAnswer
    
    // If question not answered then return false, there is no reason for checking embedded question
    if (!isChecked) {
      return false
    }

    if (!ignoreEmbeddedQuestions) {
      // Check if selected questions have embedded question
      const embeddedQuestionsForCheckedAnswers = checkedAnswers.filter(el => !!el.embeddedQuestion)
      if (embeddedQuestionsForCheckedAnswers.length) {
        const embeddedQuestionsNotAnswered = !!embeddedQuestionsForCheckedAnswers.find(el => !checkIfAnswered(el.embeddedQuestion))
        return isChecked && !embeddedQuestionsNotAnswered
      }
    }

    // Return true
    return isChecked
  }

  return true
}